import { Date } from '.';

export interface ActionDefinition {
	id: string;
	can: boolean;
	is: boolean;
	did: Date | null;
    error: Error | null;
}

export const DefaultActionDefinition: ActionDefinition = {
	id: '',
	can: true,
	is: false,
	did: null,
    error: null
};
